import React, {Component} from 'react';
import {connect} from 'react-redux';
import * as actions from '../actions';
import {Redirect} from "react-router-dom";
import {ProgressBar} from "react-materialize";
import {errorToast} from "../api/Util";
import {isSidebarLinkAllowed, firstAllowedSidebarPath} from "../constant/SidebarLinks";

/**
 * Login guard for routed pages.
 *
 * @param ComposedComponent page to render
 * @param sidebarKey        optional key from constant/SidebarLinks.js. When given, the page is only
 *                          reachable if the white label portal allows that link for the user's role
 *                          (website_type.sidebar_links_access). Users typing the URL directly are
 *                          redirected to the first link they are allowed to see.
 */
export default function(ComposedComponent, sidebarKey = null) {

    class RequireAuth extends Component {
        constructor(props) {
            super(props);
            this.accessToastShown = false;
        }

        componentDidMount() {
            this.performAuthCheck();
        }

        componentDidUpdate(prevProps) {
            if (this.props.auth !== prevProps.auth) {
                this.performAuthCheck();
            }
        }
        performAuthCheck() {
            if (!this.props.auth.loggedIn) {
                this.props.history.push('/login');
                return;
            }

            if (this.props.auth.checkingAuth) {
                return;
            }

            let skipProfile = localStorage.getItem("skipProfileForNow");

            let user = this.props.auth?.loggedInUser;

            if((user?.is_temporary_password || !user?.is_profile_completed
                || (!skipProfile && user?.is_yt_fields_filled === 1)) && this.props.location.pathname !== 'profile') {
                this.props.history.push('/profile');
            }
        }

        /**
         * @returns {"allowed"|"blocked"|"pending"} sidebar access state for this page
         */
        sidebarAccessState() {
            if (!sidebarKey) {
                return "allowed";
            }
            const user = this.props.auth?.loggedInUser;
            if (!user) {
                return "pending"; // profile still loading, decide once we know the role
            }
            if (this.props.subDomain?.loadingSubDomain) {
                return "pending";
            }
            const access = this.props.subDomain?.subDomainData?.sidebar_links_access;
            return isSidebarLinkAllowed(access, sidebarKey, user.client_type) ? "allowed" : "blocked";
        }

        render() {
            if (this.props.auth.checkingAuth) {
                return <ProgressBar />;
            }
            if(this.props.auth.loggedIn === false) {
                return <Redirect to="/login"/>
            }

            const accessState = this.sidebarAccessState();
            if (accessState === "pending") {
                return <ProgressBar />;
            }
            if (accessState === "blocked") {
                if (!this.accessToastShown) {
                    this.accessToastShown = true;
                    errorToast("You don't have access to this page");
                }
                const access = this.props.subDomain?.subDomainData?.sidebar_links_access;
                const fallback = firstAllowedSidebarPath(access, this.props.auth.loggedInUser.client_type);
                if (fallback && fallback !== this.props.location.pathname) {
                    return <Redirect to={fallback}/>;
                }
                return (
                    <div className="container" style={{padding: "60px 20px", textAlign: "center"}}>
                        <h5>Access restricted</h5>
                        <p>Your role does not have access to any page on this portal. Please contact your administrator.</p>
                    </div>
                );
            }

            return <ComposedComponent {...this.props} />
        }
    }

    function mapStateToProps({auth, subDomain}) {
        return { auth, subDomain };
    }

    return connect(mapStateToProps, actions)(RequireAuth);
}
